/**
 * Removes target="_blank" from all links inside .product-details.
 *
 * Handles dynamically loaded content (e.g. a carousel) by watching for
 * DOM changes with MutationObserver. The observer disconnects automatically
 * 3 seconds after the last batch of new links appears, assuming the carousel
 * has finished rendering by then.
 */
(function () {
  function init() {
    const container = document.querySelector('.product-details');
    if (!container) return;

    let lastCount = 0;
    let stableTimer = null;

    function removeTargetBlank() {
      const links = container.querySelectorAll('a[target="_blank"]');

      links.forEach(a => a.removeAttribute('target'));

      if (links.length > lastCount) {
        lastCount = links.length;

        // Reset the inactivity timer every time new links appear.
        clearTimeout(stableTimer);
        stableTimer = setTimeout(() => {
          // No new links for 3 s — carousel is done, stop watching.
          observer.disconnect();
        }, 3000);
      }
    }

    // Watch for any new elements added inside the container.
    const observer = new MutationObserver(removeTargetBlank);
    observer.observe(container, {
      childList: true, // detect added/removed child nodes
      subtree: true,   // include all descendants, not just direct children
    });

    // Run once immediately for links already present in the DOM.
    removeTargetBlank();
  }

  // Run after DOM is ready (works whether the script is deferred or not).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
